module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-6.636 17.054L17.216 21.7c-.802.582-1.216.296-1.216-.636V18H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h7v-3.064c0-.932.38-1.216 1.182-.634l6.252 4.644c.8.582.73 1.526-.07 2.108z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-square-3.js
// module id = 1391
// module chunks = 14